import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'
import { ThemeContextProvider } from './theme/ThemeContextProvider'

import './styles.css'
import './components/Simple/buttons.css'
import './components/Simple/contains.css'
import './components/Simple/icons.css'
import './components/Simple/texts.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeContextProvider>
      <App />
    </ThemeContextProvider>
  </React.StrictMode>,
)
